/**
 * Serviço para integração com a API Pública do DataJud
 * Resolução CNJ nº 331/2020 - Portaria CNJ nº 160/2020
 */

import api from './api';

export interface DataJudSearchParams {
  numeroProcesso?: string;
  classeProcessual?: string;
  assunto?: string;
  orgaoJulgador?: string;
  dataInicial?: string;
  dataFinal?: string;
  tribunal: string;
  page?: number;
  size?: number;
}

export interface DataJudResult {
  id: string;
  numeroProcesso: string;
  classeProcessual?: string;
  assunto?: string;
  orgaoJulgador?: string;
  dataAjuizamento?: string;
  dataAtualizacao?: string;
  nivelSigilo?: string;
  tribunal: string;
  grau?: string;
  movimentos?: any[];
  partes?: any[];
  [key: string]: any;
}

export interface DataJudResponse {
  took: number;
  timed_out: boolean;
  _shards: {
    total: number;
    successful: number;
    skipped: number;
    failed: number;
  };
  hits: {
    total: {
      value: number;
      relation: string;
    };
    max_score: number;
    hits: Array<{
      _index: string;
      _type: string;
      _id: string;
      _score: number;
      _source: DataJudResult;
    }>;
  };
}

// Tribunais disponíveis - obtidos do backend
export const tribunais = {
  'TJAC': { endpoint: 'api_publica_tjac', nome: 'Tribunal de Justiça do Acre' },
  'TJAL': { endpoint: 'api_publica_tjal', nome: 'Tribunal de Justiça de Alagoas' },
  'TJAP': { endpoint: 'api_publica_tjap', nome: 'Tribunal de Justiça do Amapá' },
  'TJAM': { endpoint: 'api_publica_tjam', nome: 'Tribunal de Justiça do Amazonas' },
  'TJBA': { endpoint: 'api_publica_tjba', nome: 'Tribunal de Justiça da Bahia' },
  'TJCE': { endpoint: 'api_publica_tjce', nome: 'Tribunal de Justiça do Ceará' },
  'TJDFT': { endpoint: 'api_publica_tjdft', nome: 'TJ do Distrito Federal e Territórios' },
  'TJES': { endpoint: 'api_publica_tjes', nome: 'Tribunal de Justiça do Espírito Santo' },
  'TJGO': { endpoint: 'api_publica_tjgo', nome: 'Tribunal de Justiça de Goiás' },
  'TJMA': { endpoint: 'api_publica_tjma', nome: 'Tribunal de Justiça do Maranhão' },
  'TJMT': { endpoint: 'api_publica_tjmt', nome: 'Tribunal de Justiça de Mato Grosso' },
  'TJMS': { endpoint: 'api_publica_tjms', nome: 'Tribunal de Justiça de Mato Grosso do Sul' },
  'TJMG': { endpoint: 'api_publica_tjmg', nome: 'Tribunal de Justiça de Minas Gerais' },
  'TJPA': { endpoint: 'api_publica_tjpa', nome: 'Tribunal de Justiça do Pará' },
  'TJPB': { endpoint: 'api_publica_tjpb', nome: 'Tribunal de Justiça da Paraíba' },
  'TJPR': { endpoint: 'api_publica_tjpr', nome: 'Tribunal de Justiça do Paraná' },
  'TJPE': { endpoint: 'api_publica_tjpe', nome: 'Tribunal de Justiça de Pernambuco' },
  'TJPI': { endpoint: 'api_publica_tjpi', nome: 'Tribunal de Justiça do Piauí' },
  'TJRJ': { endpoint: 'api_publica_tjrj', nome: 'Tribunal de Justiça do Rio de Janeiro' },
  'TJRN': { endpoint: 'api_publica_tjrn', nome: 'Tribunal de Justiça do Rio Grande do Norte' },
  'TJRS': { endpoint: 'api_publica_tjrs', nome: 'Tribunal de Justiça do Rio Grande do Sul' },
  'TJRO': { endpoint: 'api_publica_tjro', nome: 'Tribunal de Justiça de Rondônia' },
  'TJRR': { endpoint: 'api_publica_tjrr', nome: 'Tribunal de Justiça de Roraima' },
  'TJSC': { endpoint: 'api_publica_tjsc', nome: 'Tribunal de Justiça de Santa Catarina' },
  'TJSP': { endpoint: 'api_publica_tjsp', nome: 'Tribunal de Justiça de São Paulo' },
  'TJSE': { endpoint: 'api_publica_tjse', nome: 'Tribunal de Justiça de Sergipe' },
  'TJTO': { endpoint: 'api_publica_tjto', nome: 'Tribunal de Justiça do Tocantins' },
  'TRF1': { endpoint: 'api_publica_trf1', nome: 'Tribunal Regional Federal da 1ª Região' },
  'TRF2': { endpoint: 'api_publica_trf2', nome: 'Tribunal Regional Federal da 2ª Região' },
  'TRF3': { endpoint: 'api_publica_trf3', nome: 'Tribunal Regional Federal da 3ª Região' },
  'TRF4': { endpoint: 'api_publica_trf4', nome: 'Tribunal Regional Federal da 4ª Região' },
  'TRF5': { endpoint: 'api_publica_trf5', nome: 'Tribunal Regional Federal da 5ª Região' },
  'TRF6': { endpoint: 'api_publica_trf6', nome: 'Tribunal Regional Federal da 6ª Região' },
  'TRT1': { endpoint: 'api_publica_trt1', nome: 'TRT 1ª Região (RJ)' },
  'TRT2': { endpoint: 'api_publica_trt2', nome: 'TRT 2ª Região (SP)' },
  'TRT3': { endpoint: 'api_publica_trt3', nome: 'TRT 3ª Região (MG)' },
  'TRT4': { endpoint: 'api_publica_trt4', nome: 'TRT 4ª Região (RS)' },
  'TRT5': { endpoint: 'api_publica_trt5', nome: 'TRT 5ª Região (BA)' },
  'TRT6': { endpoint: 'api_publica_trt6', nome: 'TRT 6ª Região (PE)' },
  'TRT9': { endpoint: 'api_publica_trt9', nome: 'TRT 9ª Região (PR)' },
  'TRT15': { endpoint: 'api_publica_trt15', nome: 'TRT 15ª Região (Campinas)' },
  'TST': { endpoint: 'api_publica_tst', nome: 'Tribunal Superior do Trabalho' },
  'TSE': { endpoint: 'api_publica_tse', nome: 'Tribunal Superior Eleitoral' },
  'STJ': { endpoint: 'api_publica_stj', nome: 'Superior Tribunal de Justiça' },
  'STM': { endpoint: 'api_publica_stm', nome: 'Superior Tribunal Militar' },
};

/**
 * Valida o formato do número CNJ
 */
export const validarCNJ = (cnj: string): boolean => {
  // NNNNNNN-DD.AAAA.J.TR.OOOO — DD = 98 - (NNNNNNN AAAA J TR OOOO 00 mod 97), Resolução CNJ 65/2008.
  const digits = (cnj || '').replace(/\D/g, '');
  if (digits.length !== 20) return false;
  // Resto calculado dígito a dígito: o número passa de Number.MAX_SAFE_INTEGER
  const semDv = digits.slice(0, 7) + digits.slice(9) + '00';
  let resto = 0;
  for (let i = 0; i < semDv.length; i++) resto = (resto * 10 + Number(semDv[i])) % 97;
  return Number(digits.slice(7, 9)) === 98 - resto;
};

/**
 * Formata o número CNJ para exibição
 */
export const formatarCNJ = (cnj: string): string => {
  if (!cnj) return '';
  
  const numeric = cnj.replace(/\D/g, '');
  if (numeric.length === 20) {
    return `${numeric.substring(0, 7)}-${numeric.substring(7, 9)}.${numeric.substring(9, 13)}.${numeric.substring(13, 14)}.${numeric.substring(14, 18)}.${numeric.substring(18, 20)}`;
  }
  
  return cnj;
};

/**
 * Obtém lista de tribunais disponíveis
 */
export const getTribunais = async () => {
  try {
    const response = await api.get('/datajud/tribunais');
    return response.data;
  } catch (error) {
    console.error('Erro ao obter tribunais:', error);
    throw error;
  }
};

/**
 * Busca processos na API do DataJud através do backend proxy
 */
export const buscarProcessos = async (params: DataJudSearchParams): Promise<DataJudResponse> => {
  try {
    const response = await api.post('/datajud/search', params);
    return response.data.data;
  } catch (error) {
    console.error('Erro na busca de processos:', error);
    throw error;
  }
};

/**
 * Busca processo por número CNJ específico
 */
export const buscarProcessoPorCNJ = async (cnj: string, tribunal: string): Promise<DataJudResult | null> => {
  try {
    if (!validarCNJ(cnj)) {
      throw new Error('Número CNJ inválido');
    }

    const response = await api.get(`/datajud/search/cnj/${cnj}?tribunal=${tribunal}`);
    return response.data.data;
  } catch (error) {
    console.error('Erro na busca por CNJ:', error);
    throw error;
  }
};

/**
 * Busca em múltiplos tribunais simultaneamente
 */
export const buscarMultiplosTribunais = async (params: DataJudSearchParams & { tribunais: string[] }) => {
  try {
    const response = await api.post('/datajud/search/multiple', params);
    return response.data;
  } catch (error) {
    console.error('Erro na busca múltipla:', error);
    throw error;
  }
};

/**
 * Exporta resultados para CSV
 */
export const exportarCSV = async (params: DataJudSearchParams) => {
  try {
    const response = await api.post('/datajud/export/csv', params);
    return response.data;
  } catch (error) {
    console.error('Erro na exportação CSV:', error);
    throw error;
  }
};

/**
 * Formata data para exibição
 */
export const formatarData = (data: string): string => {
  if (!data) return '';
  
  try {
    const date = new Date(data);
    return date.toLocaleDateString('pt-BR');
  } catch {
    return data;
  }
};

/**
 * Extrai informações importantes de um processo
 */
export const extrairInfoProcesso = (processo: DataJudResult) => {
  return {
    numero: processo.numeroProcesso,
    classe: processo.classeProcessual || (processo.classe as any)?.nome || '',
    assunto: Array.isArray(processo.assunto) 
      ? processo.assunto.map((a: any) => a.nome || a).join(', ')
      : processo.assunto || '',
    orgaoJulgador: (processo.orgaoJulgador as any)?.nome || processo.orgaoJulgador || '',
    dataAjuizamento: formatarData(processo.dataAjuizamento || ''),
    dataAtualizacao: formatarData(processo.dataAtualizacao || ''),
    nivelSigilo: processo.nivelSigilo || '',
    grau: processo.grau || ''
  };
};

/**
 * Obtém sugestões de busca baseadas no histórico
 */
export const obterSugestoesBusca = (): string[] => {
  const historico = localStorage.getItem('datajud_historico');
  if (!historico) return [];
  
  try {
    const searches = JSON.parse(historico);
    return searches.slice(0, 5); // Últimas 5 buscas
  } catch {
    return [];
  }
};

/**
 * Salva busca no histórico
 */
export const salvarBuscaHistorico = (busca: string): void => {
  if (!busca.trim()) return;
  
  const historico = obterSugestoesBusca();
  const novoHistorico = [busca, ...historico.filter(h => h !== busca)].slice(0, 10);
  
  localStorage.setItem('datajud_historico', JSON.stringify(novoHistorico));
};

/**
 * Limpa histórico de buscas
 */
export const limparHistorico = (): void => {
  localStorage.removeItem('datajud_historico');
};

export default {
  validarCNJ,
  formatarCNJ,
  getTribunais,
  buscarProcessos,
  buscarProcessoPorCNJ,
  buscarMultiplosTribunais,
  exportarCSV,
  formatarData,
  extrairInfoProcesso,
  obterSugestoesBusca,
  salvarBuscaHistorico,
  limparHistorico
}; 